import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "../../authConfig";
import { ThemeProvider } from "@mui/material/styles";
import Dashboard from "../Dashboard/Dashboard";
import Landing from "../Landing/Landing";
import theme from "../../themes/themes";

export default function App() {
  const authRequest = {
    ...loginRequest
  };

  return (
    <ThemeProvider theme={theme}>
      <MsalAuthenticationTemplate 
        interactionType={InteractionType.Redirect} 
        authenticationRequest={authRequest}
      >
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={<Navigate replace to="/dashboard/load-boards" />} 
            />
            <Route path="dashboard/*" element={<Dashboard />} />
            <Route path="landing" element={<Landing />} />
            <Route
              path="*"
              element={
                <main style={{ padding: "1rem" }}>
                  <p>Page not found</p>
                </main>
              }
            />
          </Routes>
        </BrowserRouter>
      </MsalAuthenticationTemplate>
    </ThemeProvider>
  );
}
